import { Typography, withStyles, withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Page, ScrollView } from 'react-layout-components';
import Waypoint from 'react-waypoint';
import Container from '../common/Container';
import Footer from '../common/Footer';
import Spacing from '../common/Spacing';
import Toolbar from '../common/Toolbar';
import FadeFromDown from '../transitions/FadeFromDown';


class Works extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            worksVisibility: {}
        }
    }

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))

    doShowWork = (s) =>
        this.setState({ ...this.state, worksVisibility: { ...this.state.worksVisibility, [s]: true } })

    render() {

        const { classes } = this.props

        return (
            <Page>
                <ScrollView
                    ref="scrollElement"
                    width="100%"
                    height="100%"
                    onScroll={this.handleScroll}>

                    <div className={classes.scrollContainer}>
                        <Toolbar light elevated />

                        <div className={classes.mainContent}>
                            <Box column>
                                <Waypoint
                                    key={'aqui-zapp'}
                                    onEnter={() => this.doShowWork('aqui-zapp')}
                                    topOffset={-56}
                                    bottomOffset={56}>
                                    <div id={'aqui-zapp'}>
                                        <FadeFromDown visible={this.state.worksVisibility['aqui-zapp']}>
                                            <Container>
                                                <Box className={classes.content} column center>

                                                    <Spacing large vertical />
                                                    <Spacing large vertical />

                                                    <Box center column width="100%">
                                                        <Typography variant={'title'}>
                                                            AquiZapp
                                                    </Typography>

                                                        <Spacing large vertical />

                                                        <Typography variant={'body1'}
                                                            headlineMapping={{ body1: 'div' }}
                                                            component={(props) => <Box width="100%" {...props} />}
                                                            align={'justify'}>
                                                            Donec rutrum congue leo eget malesuada. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec sollicitudin molestie malesuada. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Vivamus suscipit tortor eget felis porttitor volutpat. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Curabitur aliquet quam id dui posuere blandit. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Sed porttitor lectus nibh. Curabitur aliquet quam id dui posuere blandit. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a.
                                                    </Typography>

                                                    </Box>

                                                    <Spacing large vertical />
                                                    <Spacing large vertical />

                                                </Box>
                                            </Container>
                                        </FadeFromDown>
                                    </div>
                                </Waypoint>
                            </Box>
                        </div>
                        <Footer />
                    </div>
                </ScrollView>
            </Page>
        )
    }

}

Works.propTypes = {
    classes: PropTypes.any,
}

Works.defaultProps = {

}

const styles = theme => ({
    scrollContainer: {
    },
    mainContent: {
        paddingTop: 64,
        minHeight: window.innerHeight - 64,
        [theme.breakpoints.down('xs')]: {
            paddingTop: 56,
            minHeight: window.innerHeight - 2 * 56,
        },
    },
    content: {
        width: '100%',
    },
    section: {

    },
    darkSection: {
        backgroundColor: theme.palette.primary.main
    }
})

export default withTheme()(withStyles(styles)(Works))


// WEBPACK FOOTER //
// ./src/components/pages/Works.js